<div class="container">
  <span class="text-wrapper">
      {{completion}}/{{total}}
    <span class="go-bold">COMPLETE</span>
  </span>
</div>
